import { consentStore } from '@mfe/store';
import { DEFAULT_MSISDN_FILTER } from '@mfe/store/ConsentStore';
import type { Callback, Unsubscribe } from '@mfec/lit/store/state';
import { customElement, property, state } from 'lit/decorators.js';

import { BaseComponent } from './BaseComponent';

@customElement('tef-coms-button')
export class TefComsButton extends BaseComponent {
  @property({ type: String }) text : string = 'Default Button Text';
  @state() disabled : boolean = false;

  unsubscribe : Unsubscribe;

  constructor() {
    super();
    this.unsubscribe = consentStore.subscribe(this.handleChosenMsisdnUpdate.bind(this) as Callback, ['chosenMsisdn']);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsubscribe();
  }

  handleChosenMsisdnUpdate() {
    if (consentStore.chosenMsisdn !== DEFAULT_MSISDN_FILTER) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  override render() {
    return this.getTemplateFn('tefComsButton')();
  }

  handleClick(event: PointerEvent) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
